<app-menu></app-menu>
<mat-toolbar color="primary"> Upload </mat-toolbar>
<mat-card>
  <mat-card class="mat-elevation-z0 card-padding">
    <mat-card-content>
      <p>Use this function to upload Delivery Packs (zip-files):
      <p>
      <ul>
        <li style="font-size: 14px;">Meta Packs and Image Packs for Dynamic Image Sets</li>
        <li style="font-size: 14px;">Static Image Packs for Static Images</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card class="mat-elevation-z0">

    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header style="padding-left:14px;">Conventions for zip-file
          names</mat-expansion-panel-header>
        <mat-grid-list cols="10" rowHeight="23px">
          <mat-grid-tile colspan="1">Meta Pack</mat-grid-tile>
          <mat-grid-tile colspan="2">meta-&lt;set-id&gt;[custom].zip</mat-grid-tile>
          <mat-grid-tile colspan="7"></mat-grid-tile>
          <mat-grid-tile colspan="1">Image Pack</mat-grid-tile>
          <mat-grid-tile colspan="2">image-ext&lt;-lhd|-rhd&gt;-&lt;set-id&gt;[custom].zip</mat-grid-tile>
          <mat-grid-tile colspan="7">image-int&lt;-lhd|-rhd&gt;-&lt;set-id&gt;[custom].zip</mat-grid-tile>
          <mat-grid-tile colspan="1">Static Image Pack</mat-grid-tile>
          <mat-grid-tile colspan="2">static-[custom].zip</mat-grid-tile>
          <mat-grid-tile colspan="7"></mat-grid-tile>
          <mat-grid-tile colspan="1">One Layer Image Pack</mat-grid-tile>
          <mat-grid-tile colspan="2">oneLayer-[custom].zip</mat-grid-tile>
          <mat-grid-tile colspan="7"></mat-grid-tile>
        </mat-grid-list>
        The dynamic image set identifier (set-id) is a 16 character LCDV matching pattern. It
        contains upper case letters A-Z and numbers 0-9 and a wildcard character
        (lower case x).
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card>
  <button mat-button color="primary">
    <h3>Select zip-file/s to upload:</h3>
  </button>
  <mat-card class="mat-elevation-z0">
    <mat-card-actions>
      <button mat-flat-button color="primary" (click)="onClick()">
        <mat-icon>attach_file</mat-icon>
        Browse
      </button>
    </mat-card-actions> </mat-card><input type="file" (change)="selectFiles($event)" #fileInput id="fileUpload"
    name="fileUpload" multiple accept="*.zip" style="display: none" />

  <mat-card class="mat-elevation-z0">
    <mat-card-content>
      <ul>
        <li *ngFor="let progressInfo of progressInfos">
          <span id="file-label">
            {{ progressInfo.fileName }}
          </span>
          <mat-progress-bar [value]="progressInfo.value"></mat-progress-bar>
          <span>{{ progressInfo.value }}% </span>
        </li>
      </ul>
    </mat-card-content>
    <mat-card-actions>
      <button mat-flat-button color="primary" [disabled]="!validatedFiles" (click)="upload()">
        <mat-icon>file_upload</mat-icon>
        Upload
      </button>
    </mat-card-actions>
  </mat-card>
</mat-card>